<template>
    <div>
        <edit-resource
            custom-class="w-768"
            v-if="formGenerated"
            :form="form"
            :title="title"
            @close="$emit('close')"
            @submit="save"
        >
            <translatable #default="{ languages, selectedLanguage }" :errors="warningTabs">
                <div v-for="lang in languages" :key="lang">
                    <simple-input v-show="lang === selectedLanguage"
                                  v-model="form[titleAttr][lang]" class="mb-16">
                        {{ $t('settings.email-templates.name') }}
                        <span v-if="languages.length > 1">
                            ({{ lang }})
                        </span>
                    </simple-input>
                </div>
            </translatable>

            <template #bottomleft v-if="type === 'model'">
                <more-info-button
                    only-use-icon
                    hide-label
                    position="top"
                    class="mr-8"
                >
                    <template #content>
                        <b class="block mb-4">{{ $t('general.more_info') }}</b>
                        <p v-html="tooltip.info"></p>
                    </template>
                </more-info-button>
                <span v-html="tooltip.title"></span>
            </template>
        </edit-resource>
    </div>
</template>

<script>
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import Form from "../../etc/forms/Form";
import EditResource from "./EditResource.vue";
import Input from "../forms/Input.vue";
import Translatable from "../forms/Translatable.vue";
import {normalizeJson} from "../../../shared/helpers";
import MoreInfoButton from "./MoreInfoButton";
import Tooltip from "../navigation/Tooltip";
import SvgIcon from './SvgIcon.vue';
import Competence from "../../models/Competence";
import CompetenceTemplate from "../../models/CompetenceTemplate";
import InterviewTemplate from "../../models/InterviewTemplate";
import Question from "../../models/Question";
import Filter from "../../models/Filter";
import FilterGroup from "../../models/FilterGroup";

export default {
    components: {
        EditResource,
        'simple-input': Input,
        Translatable,
        MoreInfoButton,
        Tooltip,
        SvgIcon
    },
    props: {
        value: Object,
        service: null
    },
    data: function () {
        return {
            form: null,
            formGenerated: false,
            models: {
                'competences': Competence,
                'competence-templates': CompetenceTemplate,
                'interview-templates': InterviewTemplate,
                'filter-groups': FilterGroup,
                'questions': Question,
                'filters': Filter,
            }
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany', 'templateModuleInfo']),
        type() {
            return this.value.hasOwnProperty('pivot') ? 'model' : 'templateModel';
        },
        entity() {
            return this.moduleInfo[this.type];
        },
        title() {
            return this.$t(this.value ? 'general.edit_subject' : 'general.add_subject', {
                subject: this.$t(`settings.${this.entity}.single`)
            });
        },
        titleAttr() {
            return this.type === "templateModel" ? 'title' : this.moduleInfo.title.attribute;
        },
        saveAction() {
            return this.type === 'templateModel' ? 'update' : 'updateItem';
        },
        activeItem: {
            get() {
                return this.value;
            },
            set(newItem) {
                this.value = newItem;
            }
        },
        moduleInfo() {
            return this.templateModuleInfo;
        },
        model() {
            return useRepo(this.models[this.entity]);
        },
        warningTabs() {
            let languages = this.currentCompany.jobsite.active_languages;
            let errorLang = [];

            for (let index in languages) {
                if (!this.form.data[this.titleAttr][languages[index]]) {
                    errorLang.push(languages[index]);
                }
            }
            return errorLang;
        },
        tooltip() {
            return {
                title: this.$t('settings.competence.change_warning_title', {
                    type: this.$t(`settings.${this.entity}.single`)
                }),
                info: this.$t('settings.competence.change_warning_info', {
                    type: this.$t(`settings.${this.entity}.single`),
                    type_m: this.$t(`settings.${this.entity}.title`),
                })
            }
        }
    },
    methods: {
        getFields() {
            return [
                {name: this.titleAttr, value: {}, translatable: true},
            ];
        },
        generateForm() {
            let fields = this.getFields();
            fields.forEach((field, index) => {
                fields[index].value = JSON.parse(JSON.stringify(this.value[field.name]));
            });

            return new Form(fields);
        },
        save() {
            this.service[this.saveAction](this.value.id, {
                data: {attributes: this.form.data},
            }).then(result => {
                this.activeItem[this.titleAttr] = result.attributes[this.titleAttr];
                this.model.save(normalizeJson(result));
                this.$emit('close');
            })
        }
    },
    mounted() {
        this.form = this.generateForm();
        this.formGenerated = true;
    }
}
</script>
